/**
 * 配送希望日選択画面 自動リダイレクト機能
 * 30分後にカート画面にリダイレクト
 * 更新: カート画面のみに限定
 */

(function () {
  'use strict';

  // 設定
  const TIMEOUT_MINUTES = 30;
  const REDIRECT_URL = '/cart';
  const REDIRECT_DELAY_SECONDS = 5; // リダイレクトまでの猶予時間（秒）

  /**
   * 初期化
   */
  function init() {
    const currentPath = window.location.pathname;

    console.log(`[AutoRedirect] 現在のページ: ${currentPath}`);

    // カート画面のみ対象
    if (window.location.pathname.startsWith('/cart')) {
      console.log(`[AutoRedirect] カート画面を検出！タイマーを開始します`);
      console.log(`[AutoRedirect] ${TIMEOUT_MINUTES * 60} 秒後にリダイレクトします`);

      // カウントダウン表示
      let countdown = TIMEOUT_MINUTES * 60;
      const countdownTimer = setInterval(() => {
        countdown--;
        if (countdown % 5 === 0 || countdown <= 5) {
          console.log(`[AutoRedirect] リダイレクトまで残り ${countdown} 秒`);
        }
        if (countdown <= 0) {
          clearInterval(countdownTimer);
        }
      }, 1000);

      setTimeout(() => {
        console.log(`[AutoRedirect] セレクトボックスをリセットします`);
        // 選択している地域をリセット
        const select = document.getElementById('cc-select-days-opt');
        if (select) { // select要素が存在するか確認
          select.selectedIndex = 0;
          // changeイベントを強制的に発火させる
          const event = new Event('change', { bubbles: true });
          select.dispatchEvent(event);
        }

        // リセット処理完了後、指定された時間（5秒）待ってからリダイレクトを実行
        console.log(`[AutoRedirect] ${REDIRECT_DELAY_SECONDS} 秒後にリダイレクトします`);
        setTimeout(() => {
          console.log(`[AutoRedirect] リダイレクト実行！ ${REDIRECT_URL} に移動します`);
          window.location.href = REDIRECT_URL;
        }, REDIRECT_DELAY_SECONDS * 1000);

      }, TIMEOUT_MINUTES * 60 * 1000);
    } else {
      console.log(`[AutoRedirect] カート画面以外のため、何もしません`);
    }
  }

  // 初期化実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();